import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { l } from '@manychat/manyui'

import { FOLLOW_REPLY_CHANNEL } from 'apps/followReply/constants'
import { FollowReplyState } from 'apps/followReply/interfaces'
import { getChannelState, NAMESPACE } from 'apps/followReply/store/constants'
import { alert } from 'common/core'
import { followReplyApi } from 'shared/api/requests/followReply'
import { createAsyncAction } from 'shared/lib/redux'

export const toggleFlow = createAsyncAction(`${NAMESPACE}/toggleFlow`, async (enabled: boolean) => {
  const updatedFlow = await followReplyApi.switch({
    body: {
      enabled: enabled ? 1 : 0,
    },
  })

  if (updatedFlow.data.enabled) {
    alert(l.translate('Follow Private reply activated'), 'success')
  } else {
    alert(l.translate('Follow Private reply deactivated'))
  }

  return updatedFlow.data
})

export const toggleFlowReducer = (builder: ActionReducerMapBuilder<FollowReplyState>) => {
  builder.addCase(toggleFlow.fulfilled, (state, action) => {
    const data = action.payload
    state[FOLLOW_REPLY_CHANNEL] = getChannelState(data)
  })
}
